// Row parsing for the four prospecting tabs. Shared by the browser (which reads
// the published CSV export) and by the sync function (which reads the same tabs
// through the Sheets API), so both see identical records.

import { cleanCell, isTruthyCell } from './prospecting-identity.mjs'

// Columns A:K are the canonical prospect block. Hot repeats a second header
// block further right, which is why anything past K is discarded.
export const PROSPECTING_COLUMN_COUNT = 11

export function findHeaderIndex(rows) {
  return rows.findIndex(
    (row) => cleanCell(row?.[0]).toLowerCase() === 'team' && cleanCell(row?.[2]).toLowerCase() === 'person',
  )
}

export function parseProspectingRows(rows, list) {
  const headerIndex = findHeaderIndex(rows)
  if (headerIndex < 0) return []

  return rows
    .slice(headerIndex + 1)
    .map((sourceRow, index) => {
      const row = Array.isArray(sourceRow) ? sourceRow.slice(0, PROSPECTING_COLUMN_COUNT) : []
      const person = cleanCell(row[2])
      if (!person) return null

      return {
        list,
        rowNumber: headerIndex + index + 2,
        team: cleanCell(row[0]),
        date: cleanCell(row[1]),
        person,
        profile: cleanCell(row[3]),
        auditSent: isTruthyCell(row[4]),
        needs: cleanCell(row[5]),
        email: cleanCell(row[6]),
        niche: cleanCell(row[7]),
        phone: cleanCell(row[8]),
        bookedCall: isTruthyCell(row[9]),
        website: cleanCell(row[10]),
        // The untouched source cells, so a reconciled row lands in Leads exactly
        // as William typed it instead of being re-serialized from parsed values.
        raw: Array.from({ length: PROSPECTING_COLUMN_COUNT }, (_, column) => (
          row[column] === null || row[column] === undefined ? '' : String(row[column])
        )),
      }
    })
    .filter(Boolean)
}
